import type { TypeDatasetData } from './types';

import toArray from '../toArray';

import removeDataset from './removeDataset';
import setDataset from './setDataset';
import setDatasetData from './setDatasetData';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        removeDataset(data: string | string[]): HTMLElement;
        setDataset(key: string, value: string): HTMLElement;
        setDatasetData(data: TypeDatasetData): HTMLElement;
    }
    interface NodeList {
        removeDataset(data: string | string[]): NodeList;
        setDataset(key: string, value: string): NodeList;
        setDatasetData(data: TypeDatasetData): NodeList;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.removeDataset = function (data: string | string[]): HTMLElement {
    removeDataset(this, data);

    return this;
};

NodeList.prototype.removeDataset = function (data: string | string[]): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            removeDataset(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setDataset = function (key: string, value: string): HTMLElement {
    setDataset(this, key, value);

    return this;
};

NodeList.prototype.setDataset = function (key: string, value: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setDataset(element, key, value);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setDatasetData = function (data: TypeDatasetData): HTMLElement {
    setDatasetData(this, data);

    return this;
};

NodeList.prototype.setDatasetData = function (data: TypeDatasetData): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setDatasetData(element, data);
        }
    }

    return this;
};
